const $ = require("jquery");

$(document).ready(function() {
    $(".content_toggle_button").click(elm => {
        $(elm).addClass("content_toggle_hidden");
        $(".content_toggle_hide_content").addClass("content_toggle_hidden");
        $(".toggle_content_wrapper").removeClass("content_toggle_hidden");
    });
});
